import React, { useState } from "react";
import axios from "axios";
import { ToastContainer, toast, Zoom, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useAuth } from "../../context/auth";
import { useMutation, useQuery } from "react-query";
import { useNavigate, useParams } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css";
import { ThreeDots } from "react-loader-spinner";
const RequestDetail = () => {
  const { token, user } = useAuth();
  const [userId, setUserId] = useState(null);
  const [rejectId, setRejectId] = useState(null);

  const { id } = useParams();
  const navigate = useNavigate();
  const headers = {
    "Content-Type": "application/json",
    Accept: "application/json",
    Authorization: `Bearer ${token}`,
  };
  const requestDetailsData = useQuery(
    ["requestDetailsDataApi", id],
    async () =>
      await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}company/request/${id}`,
        {
          headers,
        }
      ),
    {
      keepPreviousData: false,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!token,
      onSuccess: (res) => {},
    }
  );

  //accept request
  const acceptRequestMutation = useMutation(
    async (newData) =>
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}company/request/${id}`,
        newData,
        {
          headers,
        }
      ),
    {
      retry: false,
    }
  );

  const acceptRequestHandler = async (values) => {
    try {
      acceptRequestMutation.mutate(
        { userId: id },
        {
          onSuccess: (responseData) => {
            toast.info(
              "request accepted successfully",
              { theme: "colored" },
              {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
              }
            );
            setTimeout(() => {
              navigate("/company");
            }, 1200);
          },
          onError: (err) => {
            console.log({ err });
            toast.error(err?.response?.data?.message, {
              style: {
                backgroundColor: "#dc2626",
                color: "white",
              },
            });
          },
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  const rejectRequestHandler = (id) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="bg-[#edf2f6]  p-4 py-4 flex items-center flex-col space-y-2">
            <h1 className="text-dark-color font-bold">
              Are You Sure, You want to reject this request ?
            </h1>

            <div className="flex items-center justify-center space-x-5 w-full">
              <button
                onClick={onClose}
                className="bg-blue-bg rounded-sm text-center
                     px-5 p-2 font-medium text-sm text-white capitalize"
              >
                No
              </button>
              <button
                onClick={() => {
                  onClose();
                  setRejectId(id);
                }}
                className="bg-red-500 rounded-sm text-center
              px-5 p-2 font-medium text-sm text-white capitalize"
              >
                Yes
              </button>
            </div>
          </div>
        );
      },
    });
  };
  const rejectRequestData = useQuery(
    ["requestDetailsDataApi", rejectId],
    async () =>
      await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}company/request/reject/${rejectId}`,
        {
          headers,
        }
      ),
    {
      keepPreviousData: false,
      refetchOnWindowFocus: false,
      retry: false,
      enabled: !!token && !!rejectId,
      onSuccess: (res) => {
        toast.info(
          "request rejected successfully",
          { theme: "colored" },
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
          }
        );
        setTimeout(() => {
          setRejectId(null);
          navigate("/company");
        }, 2000);
      },
    }
  );
  return (
    <div className="p-3 md:p-10">
      <div className="bg-white dark:bg-secondary-dark-bg rounded-md p-3 md:p-5">
        <div className=" grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            {requestDetailsData.isFetched ? (
              <div className=" flex flex-col items-start space-y-3 ">
                <h1 className="font-bold text-2xl text-dark-color dark:text-white">
                  Company Information
                </h1>
                <div>
                  <img
                    src={requestDetailsData?.data?.data?.data?.logo}
                    alt=""
                    className="h-44 py-2"
                  />
                  <h1 className="text-dark-color dark:text-white md:text-lg">
                    Company Name:{" "}
                    <span className="text-dark-gray">
                      {requestDetailsData?.data?.data?.data?.name}
                    </span>
                  </h1>
                  <h1 className="text-dark-color dark:text-white md:text-lg">
                    Company Email:{" "}
                    <span className="text-dark-gray">
                      {requestDetailsData?.data?.data?.data?.email}
                    </span>
                  </h1>
                  <h1 className="text-dark-color dark:text-white md:text-lg">
                    Company Phone:{" "}
                    <span className="text-dark-gray">
                      {requestDetailsData?.data?.data?.data?.phone}
                    </span>
                  </h1>
                  <p className="text-dark-color dark:text-white md:text-lg">
                    Address:{" "}
                    <span className="text-dark-gray">
                      {requestDetailsData?.data?.data?.data?.address}
                    </span>
                  </p>
                  <p className="text-dark-color dark:text-white md:text-lg">
                    Comment:{" "}
                    <span className="text-dark-gray">
                      {requestDetailsData?.data?.data?.data?.comment}
                    </span>
                  </p>
                </div>
              </div>
            ) : (
              <div className="flex items-center justify-center">
                <ThreeDots
                  height="80"
                  width="80"
                  radius="9"
                  color="#216fed"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={true}
                />
              </div>
            )}
          </div>
          {/* second grid */}
          <div>
            {requestDetailsData.isFetched ? (
              <div className=" flex flex-col items-start space-y-3 ">
                <h1 className="font-bold text-2xl text-dark-color dark:text-white">
                  User Information
                </h1>

                <div>
                  <img
                    src={requestDetailsData?.data?.data?.user?.profile}
                    alt=""
                    className="h-14 w-14 object-cover rounded-full"
                  />
                  <h1 className="text-dark-color dark:text-white md:text-lg">
                    Name:{" "}
                    <span className="text-dark-gray">
                      {requestDetailsData?.data?.data?.user?.firstName +
                        " " +
                        requestDetailsData?.data?.data?.user?.lastName}
                    </span>
                  </h1>
                  <h1 className="text-dark-color dark:text-white md:text-lg">
                    Email:{" "}
                    <span className="text-dark-gray">
                      {requestDetailsData?.data?.data?.user?.email}
                    </span>
                  </h1>
                  <h1 className="text-dark-color dark:text-white md:text-lg">
                    Phone:{" "}
                    <span className="text-dark-gray">
                      {requestDetailsData?.data?.data?.user?.phone}
                    </span>
                  </h1>
                </div>
              </div>
            ) : (
              <div className="flex items-center justify-center">
                <ThreeDots
                  height="80"
                  width="80"
                  radius="9"
                  color="#216fed"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={true}
                />
              </div>
            )}
          </div>
        </div>
        <div className="flex items-center space-x-2 justify-center pt-5">
          <button
            onClick={acceptRequestHandler}
            className="bg-blue-bg rounded-sm text-center flex items-center justify-center
                     px-10 p-2 font-medium text-sm text-white capitalize"
          >
            {acceptRequestMutation.isLoading ? (
              <ThreeDots
                height="25"
                width="50"
                radius="9"
                color="#fff"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={true}
              />
            ) : (
              "Accept Request"
            )}
          </button>
          <button
            onClick={() => rejectRequestHandler(id)}
            className="bg-blue-bg rounded-sm text-center
                     px-10 p-2 font-medium text-sm text-white capitalize"
          >
            Reject Request
          </button>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        transition={Slide}
      />
    </div>
  );
};

export default RequestDetail;
